module.exports = __webpack_public_path__ + "static/media/slider-img01.70c55833.jpg";